import { render, staticRenderFns } from "./payChannelInfoModal.vue?vue&type=template&id=30ebbe68&scoped=true"
import script from "./payChannelInfoModal.vue?vue&type=script&lang=js"
export * from "./payChannelInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ebbe68",
  null
  
)

export default component.exports